import { Injectable, inject } from '@angular/core';
import { OpportunityWorkflowBridge } from './opportunity-workflow.bridge';

const PERSISTENCE_OWNER_KEY = 'los_opportunity_persistence_user_id';

/**
 * Ensures Opportunity IndexedDB data is not shared across staff users or after logout.
 */
@Injectable({ providedIn: 'root' })
export class OpportunityPersistenceGuardService {
  private readonly workflow = inject(OpportunityWorkflowBridge);

  async ensurePersistenceOwner(userId: string | null | undefined): Promise<void> {
    const id = userId?.trim() ?? '';
    if (!id) {
      return;
    }
    const previous = localStorage.getItem(PERSISTENCE_OWNER_KEY)?.trim() ?? '';
    if (previous && previous !== id) {
      await this.workflow.resetModulePersistence();
    }
    localStorage.setItem(PERSISTENCE_OWNER_KEY, id);
  }

  async clearOnLogout(): Promise<void> {
    localStorage.removeItem(PERSISTENCE_OWNER_KEY);
    await this.workflow.resetModulePersistence();
  }
}
